import { render, staticRenderFns } from "./SystemPerformanceChart.vue?vue&type=template&id=26123338"
import script from "./SystemPerformanceChart.vue?vue&type=script&lang=js"
export * from "./SystemPerformanceChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports